export const STATUS_DEACTIVATED = 'DEACTIVATED'
export const STATUS_SETUP = 'SETUP'
export const STATUS_TEMPORARILY_DEACTIVATED = 'TEMPORARILY_DEACTIVATED'
export const DEFAULT_COMPANY_NAME = 'unnamed'
export const SETUP_COMPANY_NAME = 'Account'
